export const isValidKeychainName = (str: string, min?: number, max?: number): true | string => {
  if (str.length < min) return `Must be greater than ${min - 1} characters`
  else if (str.length > max) return `Must be fewer than ${max} characters`
  else {
    const bool = str.match(/^[a-zA-Z0-9_\-]*$/);
    if (bool) return true
    else return "Must be alphanumeric"
  }
}
